(() => {
  const translations = new Map(Object.entries({
    'A spalla': 'Shoulder Bags',
    'Abiti': 'Dresses',
    'Accessori': 'Accessories',
    'Borse': 'Bags',
    'Camicie': 'Shirts',
    'Canotta': 'Tank Tops',
    'Cappelli': 'Hats',
    'Ciabatte': 'Slides',
    'Cinture': 'Belts',
    'Classica': 'Classic',
    'Felpe': 'Sweatshirts',
    'Giacche': 'Jackets',
    'Gilet': 'Vests',
    'Giubbotti e Giacche': 'Coats & Jackets',
    'Giubbotti Smanicati': 'Sleeveless Jackets',
    'Gonne': 'Skirts',
    'Grucce': 'Hangers',
    'Guanti': 'Gloves',
    'Intimo': 'Underwear',
    'Maglie': 'Knitwear',
    'Mare': 'Beachwear',
    'Occhiali da Sole': 'Sunglasses',
    'Pantaloni': 'Pants',
    'Pantaloni tuta': 'Sweatpants',
    'Pantofole': 'Slippers',
    'Portafogli': 'Wallets',
    'Sabot': 'Mules',
    'Sandali': 'Sandals',
    'Sciarpe': 'Scarves',
    'Short': 'Shorts',
    'Stivaletti': 'Ankle Boots',
    'Tuta': 'Tracksuits',
    'Zaini': 'Backpacks',
    'Vendor': 'Brand',
    'Product vendor': 'Brand',
    'Target gender': 'Gender',
    'Fabric': 'Material'
  }));

  const preferredOrder = ['Availability', 'Price', 'Gender', 'Brand', 'Product type', 'Size', 'Color', 'Material'];

  function translateExactText(root) {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const original = node.nodeValue;
      const trimmed = original.trim();
      const replacement = translations.get(trimmed);
      if (!replacement) return;
      const start = original.indexOf(trimmed);
      node.nodeValue = `${original.slice(0, start)}${replacement}${original.slice(start + trimmed.length)}`;
    });
  }

  function filterTitle(filter) {
    const candidates = filter.querySelectorAll('.filter__toggle .font-bold, .filter__label .font-bold, .filter__toggle .flex-auto');
    for (const el of candidates) {
      const text = el.textContent.trim();
      if (text) return translations.get(text) || text;
    }
    return '';
  }

  function reorderFilters(root) {
    const container = root?.querySelector('.facets__filters');
    if (!container) return;
    const filters = Array.from(container.children).filter((el) => el.classList?.contains('filter'));
    filters.sort((a, b) => {
      const ai = preferredOrder.indexOf(filterTitle(a));
      const bi = preferredOrder.indexOf(filterTitle(b));
      const ar = ai === -1 ? 999 : ai;
      const br = bi === -1 ? 999 : bi;
      return ar - br;
    });
    filters.forEach((filter) => container.appendChild(filter));
  }

  function enhance() {
    const root = document.querySelector('facet-filters');
    if (!root) return;
    translateExactText(root);
    reorderFilters(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance, { once: true });
  } else {
    enhance();
  }

  document.addEventListener('on:facet-filters:updated', () => requestAnimationFrame(enhance));

  const observer = new MutationObserver(() => requestAnimationFrame(enhance));
  const startObserver = () => {
    const root = document.querySelector('facet-filters');
    if (root) observer.observe(root, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  else startObserver();
})();
